import API from 'constants/API';

import {AxiosResponse} from 'axios';
import {CreateBreweryDTO, GetBreweriesDTO, GetBreweryBeersDTO} from 'typescript/dto/BreweriesDto';
import GetBreweryPubsDTO from 'typescript/dto/breweryPubsDto';
import ApiData from 'typescript/interfaces/ApiData';
import Brewery from 'typescript/models/Brewery';
import PubPage from 'typescript/models/PubPage';
import {queryBuilder} from 'utils/helpers/queryBuilder';
import httpClient from 'utils/httpClient/httpClient';

export const getBreweriesData = (dto: GetBreweriesDTO): Promise<AxiosResponse<ApiData<Brewery[]>>> => {
  const {perPage, page, name, direction, column, beerStyles, breweryTypeQuery} = dto;

  const baseQuery = queryBuilder({
    baseQuery: `${API.BREWERIES_SERVICE.BASE}?`,
    queryObject: {page, per_page: perPage, 'filter_search[brewery_name]': name},
  });

  let optionalQueryParams = '';
  if (column && direction) {
    optionalQueryParams = queryBuilder({
      baseQuery,
      queryObject: {'filter_sort[sort_column]': column, 'filter_sort[sort_direction]': direction},
    });
  }
  if (beerStyles && beerStyles.length > 0) {
    optionalQueryParams = queryBuilder({baseQuery, queryObject: {'filter_sort[sort_direction]': beerStyles}});
  }

  if (breweryTypeQuery) optionalQueryParams += breweryTypeQuery;

  return httpClient.get(optionalQueryParams || baseQuery);
};

export const createNewBrewery = (newBrewery: CreateBreweryDTO): Promise<AxiosResponse<Brewery>> => {
  const data = {brewery: newBrewery};

  return httpClient.post(API.BREWERIES_SERVICE.BASE, data);
};

export const getSingleBreweryData = (id: string): Promise<AxiosResponse<ApiData<Brewery>>> => {
  return httpClient.get(`${API.BREWERIES_SERVICE.BASE}/${id}`);
};

export const updateSingleBreweryData = (
  id: string,
  updatedBrewery: CreateBreweryDTO,
): Promise<AxiosResponse<Brewery>> => {
  const data = {brewery: updatedBrewery};

  return httpClient.put(`${API.BREWERIES_SERVICE.BASE}/${id}`, data);
};

export const getBreweryPubsList = (
  id: string,
  search: GetBreweryPubsDTO,
): Promise<AxiosResponse<ApiData<PubPage[]>>> => {
  const {page, perPage} = search;

  return httpClient.get(`${API.BREWERIES_SERVICE.BASE}/${id}/pubs?page=${page}&per_page=${perPage}`);
};

export const getBreweryBeers = (dto: GetBreweryBeersDTO) => {
  const {id, perPage, name, column, direction, beerStyles} = dto;

  let baseQuery = queryBuilder({
    baseQuery: `${API.BREWERIES_SERVICE.BASE}/${id}/beers?`,
    queryObject: {
      per_page: perPage,
      'filter_search[brewery_name]': name,
      'filter_sort[sort_column]': column,
      'filter_sort[sort_direction]': direction,
    },
  });

  if (beerStyles && beerStyles.length > 0) baseQuery += beerStyles;

  return httpClient.get(baseQuery);
};

export const getTopBreweries = (): Promise<AxiosResponse<ApiData<Brewery[]>>> => {
  return httpClient.get(`${API.BREWERIES_SERVICE.TOP_BREWERIES}`);
};
